import { render, staticRenderFns } from "./apipage.vue?vue&type=template&id=02f14b5a&scoped=true&"
import script from "./apipage.vue?vue&type=script&lang=js&"
export * from "./apipage.vue?vue&type=script&lang=js&"
import style0 from "./apipage.vue?vue&type=style&index=0&id=02f14b5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f14b5a",
  null
  
)

export default component.exports